<template>
    <div class="filters">
        <div class="row mb-4">
            <div class="col-md-12">
                <base-input :label="$t('logs.item-types')">
                    <el-select v-model="selectedTypes"
                            multiple
                            class="select-info"
                            :placeholder="$t('logs.select-types')"
                            @change="changed">

                        <el-option v-for="(type, id) in filteringTypes"
                                :key="id"
                                :label="types[id].name[lang]"
                                :value="id"
                                class="select-primary"
                        >
                            <i :class="type.icon + ' text-' + type.color + ' mr-2'"></i>{{ types[id].name[lang] }}
                        </el-option>

                    </el-select>
                </base-input>
                <div class="row pt-3">
                    <div class="col-md-6">
                        <base-button type="white mr-1" size="sm" @click="selectAllTypes">
                            {{ $t('common.select-all') }}
                        </base-button>
                        
                        <base-button type="white" size="sm" @click="unselectAllTypes">
                            {{ $t('common.unselect-all') }}
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <base-input :label="$t('logs.item-competencies')">
                    <el-select v-model="selectedCompetencies"
                            multiple
                            class="select-info"
                            :placeholder="$t('logs.select-competencies')"
                            @change="changed">

                            <el-option v-for="(competency, id) in competencies"
                                    :key="id"
                                    :label="competency['name_'+lang]"
                                    :value="id"
                                    class="select-primary"
                            >
                                {{ competency['name_'+lang] }}
                            </el-option>
                    </el-select>
                </base-input>
                <div class="row pt-3">
                    <div class="col-md-6">
                        <base-button type="white mr-1" size="sm" @click="selectAllCompetencies">
                            {{ $t('common.select-all') }}
                        </base-button>
                        
                        <base-button type="white" size="sm" @click="unselectAllCompetencies">
                            {{ $t('common.unselect-all') }}
                        </base-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <base-checkbox class="mb-3 d-inline-block" v-model="showCompetencies">
                            {{ $t('logs.show-competencies') }}
                        </base-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="text-center pt-2">
                    <base-button type="primary" @click="apply" :disabled="!hasChanged">
                        {{ $t('common.apply') }}
                    </base-button>
                    <base-button type="link" @click="cancel">
                        {{ $t('common.cancel') }}
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                default: {}
            },

            types: {
                type: Object,
                required: true
            },
            
            competencies: {
                type: Object,
                default: null
            },

            lang: {
                type: String,
                default: "en"
            },

            restore: {
                type: Boolean,
                default: false
            },

            modal: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                selectedTypes: [],
                selectedCompetencies: [],
                showCompetencies: false,
                hasChanged: false,
                savedFilters: this.$auth.getUiConfig('log_filters')
            }
        },

        created() {
            if (this.restore && this.savedFilters) {
                this.$emit('input', this.savedFilters)
            }
        },

        mounted() {
            this.cancel()
        },

        watch: {

            showCompetencies(newVal) {
                this.changed()
            },

            value(newVal) {
                this.cancel()
            }
        },

        computed: {

            filteringTypes() {
                const types = {...this.types}
                delete types.position_change
                return types
            },
        },

        methods: {

            selectAllTypes() {
                this.selectedTypes = Object.keys(this.filteringTypes);
                this.changed()
            },

            unselectAllTypes() {
                this.selectedTypes = []
                this.changed()
            },

            selectAllCompetencies() {
                this.selectedCompetencies = Object.keys(this.competencies)
                this.changed()
            },

            unselectAllCompetencies() {
                this.selectedCompetencies = []
                this.changed()
            },

            changed() {
                this.hasChanged = true
            },

            apply() {
                this.$loader.show()
                setTimeout(this.applyNow, 300)
            },

            applyNow() {
                this.$emit('input', this.filters())
                this.$nextTick(() => {
                    this.hasChanged = false
                    this.$loader.hide()
                    this.rememberFilters()
                })
            },

            cancel() {
                this.selectedTypes = this.value.selectedTypes
                this.selectedCompetencies = this.value.selectedCompetencies
                this.showCompetencies = this.value.showCompetencies
                this.$nextTick(() => {
                    this.hasChanged = false
                })
                this.modal.show = false
            },

            rememberFilters() {
                this.$auth.setUiConfig(this.filters(), 'log_filters')
            },

            filters() {
                return {
                    selectedTypes: this.selectedTypes,
                    selectedCompetencies: this.selectedCompetencies,
                    showCompetencies: this.showCompetencies,
                }
            },
        }
    }
</script>

<style scoped>

    .filters >>> .form-group {
        margin-bottom: 0;
    }
    .filters >>> .el-select.select-info .el-select__tags .el-tag {
        background: #5e72e4;
    }

</style>
